import _ from 'lodash';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';
import * as SponsorGroupActions from './sponsor-group.actions';

export const sponsorGroupFeatureKey = 'sponsorGroup';

export interface State extends EntityState<any>{
}

export const adapter: EntityAdapter<any> = createEntityAdapter<any>();

export const initialState: State = adapter.getInitialState({
});

export const reducer = createReducer(
  initialState,

  on(SponsorGroupActions.getSponsorGroupList, state => state),
  on(SponsorGroupActions.getSponsorGroupListSuccess, (state, action) => {
    let { data: list } = action;
    return adapter.upsertMany(list, adapter.removeAll(state));
  }),
  on(SponsorGroupActions.getSponsorGroupListFailure, (state, action) => state),

  on(SponsorGroupActions.resetSponsorGroupList, (state, action) => {
    return adapter.removeAll(state);
  }),
  on(SponsorGroupActions.resetSponsorGroupListSuccess, state => state),
  on(SponsorGroupActions.resetSponsorGroupListFailure, state => state),

);

